import { render, staticRenderFns } from "./UpdateWorkOrdersNewModal.vue?vue&type=template&id=c4d5b6c2&"
import script from "./UpdateWorkOrdersNewModal.vue?vue&type=script&lang=js&"
export * from "./UpdateWorkOrdersNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports